import React from 'react'
import { BsFillArrowUpCircleFill } from 'react-icons/bs'

import './FooterStyles.css'

import { Link as LinkRoll } from 'react-scroll'

const Footer = () => {
    return (

<>
        <div className='footer'>
            <div className="container">
                <div className="top">
                    <div className="logo-footer">
                    <h1>Alwyn Funa</h1>

                    </div>
                    <LinkRoll activeClass="active" to="top" spy={true} smooth={true} duration={500} >
                        <BsFillArrowUpCircleFill className='footer-icon' />
                    </LinkRoll>

                </div>
                <div className="col-container">

                    <div className="col">
                        <h3>My Work</h3>

                        <LinkRoll activeClass="active" to="aboutMe" spy={true} smooth={true} duration={500} >
                        <p>ABOUT ME</p>
                        </LinkRoll>

                        <LinkRoll activeClass="active" to="myWork" spy={true} smooth={true} duration={500} >
                        <p>REELS</p>
                        </LinkRoll>

                    </div>


                    <div className="col">
                        <h3>Quick Links</h3>
                        
                        <LinkRoll activeClass="active" to="Software" spy={true} smooth={true} duration={500} >
                        <p>SOFTWARE</p>
                        </LinkRoll>

                        <LinkRoll activeClass="active" to="Contact" spy={true} smooth={true} duration={500} >
                        <p>CONTACT</p>
                        </LinkRoll>

                    </div>

                </div>


                <p className='copyright'><p>&copy; 2024 Alwyn Funa. All rights reserved</p></p>


            </div>

        </div>
</>
    )
}

export default Footer
